import { useRef, useState } from "react";

import {
 C,
 FEEDBACK,
 MAX_PER_PRODUCT,
 ORDER_STATUS,
 SHIPPING_ZONES,
  calcCapacity,
  calcProductLoad,
  calcTotals,
  fmtDate,
  fmtMoney,
  genId,
  todayStr
} from "../data/handcraftsConfig";

function createFallbackItem(product) {
  return {
    productId: product?.id ?? null,
    name: product?.name ?? "Producto personalizado",
    qty: 1,
    price: Number(product?.price) || 0
  };
}

function AdminOrderBreakdown({ items, zoneId }) {
  const { subtotal, shipping, total, zone } = calcTotals(items, zoneId);
  return (
    <div style={{background:C.surface,borderRadius:2,padding:"16px 18px",border:`1.5px solid ${C.rule}`}}>
      <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:10}}>Desglose del Pedido</div>
      {items.map((item,i) => (
        <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <span style={{fontSize:"var(--text-body)",color:C.ink}}>{item.name} × {item.qty}</span>
          <span style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(item.price*item.qty)}</span>
        </div>
      ))}
      <div style={{borderTop:`1.5px solid ${C.rule}`,margin:"10px 0"}}/>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>Subtotal</span>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(subtotal)}</span>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>Envío — {zone.label}</span>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>{shipping===0?"Gratis":fmtMoney(shipping)}</span>
      </div>
      <div style={{borderTop:`1.5px solid ${C.rule}`,margin:"10px 0"}}/>
      <div style={{display:"flex",justifyContent:"space-between"}}>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>TOTAL</span>
        <span style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(total)}</span>
      </div>
    </div>
  );
}

function AdminNewOrder({ orders, onSave, onClose, products }) {
  const safeProducts = Array.isArray(products) ? products : [];
  const defaultItem = createFallbackItem(safeProducts[0]);
  const [step, setStep]  = useState(1);
  const [cust, setCust]  = useState({ name:"", phone:"", instagram:"" });
  const [addr, setAddr]  = useState({ street:"", city:"", dept:"", country:"El Salvador", notes:"" });
  const [zone, setZone]  = useState("sv_metro");
  const [items, setItems]= useState([defaultItem]);
  const [notes, setNotes]= useState("");
  const [isPaid, setIsPaid]   = useState(false);
  const [payMethod, setPay]   = useState("");
  const { active, max } = calcCapacity(orders);
  const productLoad = calcProductLoad(orders);
  const ok = active < max;

  const inp = (val, cb, ph, type="text") => (
    <input type={type} value={val} onChange={cb} placeholder={ph}
      style={{width:"100%",padding:"11px 14px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",background:C.surface,boxSizing:"border-box"}}
      onFocus={e=>e.target.style.borderColor=C.ink} onBlur={e=>e.target.style.borderColor=C.rule}/>
  );

  const updateItem = (idx, field, val) => {
    setItems(prev => prev.map((it,i) => {
      if (i!==idx) return it;
      if (field==="productId") {
        const p = safeProducts.find(x => String(x.id) === String(val));
        if (!p) return it;
        return { ...it, productId:p.id, name:p.name, price:Number(p.price) || 0 };
      }
      if (field==="qty") return { ...it, qty:Math.max(1,Number(val)||1) };
      if (field==="price") return { ...it, price:Math.max(0,Number(val)||0) };
      return { ...it, [field]: val };
    }));
  };
  const STEPS = ["Cliente","Productos","Envío","Resumen"];
  const { total } = calcTotals(items, zone);

  const saveIt = () => onSave({ id:genId(), createdAt:todayStr(), status:"pending", customer:cust, address:addr, shippingZone:zone, items, notes, isPaid, payMethod });

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(92,68,56,.45)",zIndex:600,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.background,borderRadius:2,width:"100%",maxWidth:540,maxHeight:"92vh",overflow:"hidden",display:"flex",flexDirection:"column"}}>
        <div className="on-ink" style={{background:C.ink,padding:"20px 26px",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontSize:"var(--text-body)",color:C.background}}>Nuevo Pedido <span style={{fontSize:"var(--text-body)",opacity:.7}}>({active}/{max})</span></div>
            <button onClick={onClose} style={{background:C.inkStrong,border:"none",borderRadius:2,width:30,height:30,cursor:"pointer",color:C.background,fontSize:"var(--text-body)"}}>✕</button>
          </div>
          <div style={{display:"flex",gap:3}}>
            {STEPS.map((_,i)=><div key={i} style={{flex:1,height:4,borderRadius:2,background:i+1<=step?C.background:C.rule,cursor:i+1<step?"pointer":"default"}} onClick={()=>i+1<step&&setStep(i+1)}/>)}
          </div>
          <div style={{display:"flex",marginTop:4}}>
            {STEPS.map((s,i)=><div key={i} className="label" style={{flex:1,color:i+1<=step?C.background:C.rule,textAlign:"center"}}>{s}</div>)}
          </div>
        </div>

        {!ok && <div style={{background:C.surface,padding:"10px 20px",fontSize:"var(--text-body)",color:FEEDBACK.error,flexShrink:0}}>Capacidad llena ({max}/{max}). Finaliza pedidos antes de agregar más.</div>}

        <div style={{flex:1,overflow:"auto",padding:"22px 26px"}}>
          {step===1 && (
            <div>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:16,color:C.ink}}>Cliente</h3>
              {[["name","Nombre *","Nombre y apellido"],["phone","Teléfono/WhatsApp *","0000-0000"],["instagram","Instagram","@cliente"]].map(([k,l,ph])=>(
                <div key={k} style={{marginBottom:12}}>
                  <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:4}}>{l}</label>
                  {inp(cust[k], e=>setCust(p=>({...p,[k]:e.target.value})), ph)}
                </div>
              ))}
            </div>
          )}
          {step===2 && (
            <div>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:16,color:C.ink}}>Productos</h3>
              {safeProducts.length===0 && (
                <div style={{background:C.surface,borderRadius:2,padding:"12px 14px",marginBottom:12,fontSize:"var(--text-body)",color:FEEDBACK.warning,border:`1px solid ${C.rule}`}}>
                 No hay productos cargados en el catalogo. Anade un producto primero desde la pestana de stock para crear pedidos sin errores.
                </div>
              )}
              {items.map((item,idx)=>{
                const load = productLoad[item.productId]||0;
                const over = load+item.qty > MAX_PER_PRODUCT;
                return (
                  <div key={idx} style={{background:C.surface,borderRadius:2,padding:14,marginBottom:10,border:`1.5px solid ${over?C.surface:C.surface}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                      <span style={{fontSize:"var(--text-label)",color:C.ink}}>Producto {idx+1}</span>
                      {items.length>1&&<button onClick={()=>setItems(p=>p.filter((_,i)=>i!==idx))} style={{background:C.surface,border:"none",borderRadius:2,padding:"2px 8px",cursor:"pointer",fontSize:"var(--text-label)",color:FEEDBACK.error}}>Quitar</button>}
                    </div>
                    <select value={item.productId ?? ""} onChange={e=>updateItem(idx,"productId",e.target.value)} disabled={safeProducts.length===0}
                      style={{width:"100%",padding:"10px 12px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",background:C.surface,outline:"none",marginBottom:8,boxSizing:"border-box"}}>
                      {safeProducts.length===0 ? (
                        <option value="">Sin productos disponibles</option>
                      ) : (
                        safeProducts.map(p=><option key={p.id} value={String(p.id)}>{p.name} — {fmtMoney(p.price)}</option>)
                      )}
                    </select>
                    <div style={{display:"flex",gap:10,alignItems:"flex-end"}}>
                      <div>
                        <div style={{fontSize:"var(--text-label)",color:C.ink,marginBottom:3}}>Cant.</div>
                        <input type="number" min={1} value={item.qty} onChange={e=>updateItem(idx,"qty",e.target.value)}
                          style={{width:65,padding:"8px 10px",borderRadius:2,border:`2px solid ${over?C.surface:C.surface}`,fontSize:"var(--text-body)",outline:"none"}}/>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:"var(--text-label)",color:C.ink,marginBottom:3}}>Precio unit.</div>
                        <input type="number" value={item.price} onChange={e=>updateItem(idx,"price",Number(e.target.value))}
                          style={{width:"100%",padding:"8px 10px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",boxSizing:"border-box"}}/>
                      </div>
                      <div style={{textAlign:"right",paddingBottom:2}}>
                        <div style={{fontSize:"var(--text-label)",color:C.ink,marginBottom:3}}>Total</div>
                        <div style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(item.price*item.qty)}</div>
                      </div>
                    </div>
                    {over&&<div style={{marginTop:6,fontSize:"var(--text-label)",color:FEEDBACK.warning}}>Alta carga para este producto ({load} activos)</div>}
                  </div>
                );
              })}
              <button onClick={()=>setItems(p=>[...p,createFallbackItem(safeProducts[0])])} disabled={safeProducts.length===0}
                style={{width:"100%",padding:10,borderRadius:2,border:`2px dashed ${C.ink}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:safeProducts.length===0?"not-allowed":"pointer",opacity:safeProducts.length===0?.6:1}}>+ Agregar producto</button>
              <div style={{marginTop:12}}>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:4}}>Notas / Personalización</label>
                <textarea value={notes} onChange={e=>setNotes(e.target.value)} rows={3} placeholder="Colores, detalles especiales..."
                  style={{width:"100%",padding:"11px 14px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",resize:"vertical",background:C.surface,lineHeight:1.6,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.ink} onBlur={e=>e.target.style.borderColor=C.rule}/>
              </div>
            </div>
          )}
          {step===3 && (
            <div>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:16,color:C.ink}}>Envío</h3>
              <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:14}}>
                {SHIPPING_ZONES.map(z=>(
                  <label key={z.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 14px",borderRadius:2,border:`2px solid ${zone===z.id?C.ink:C.surface}`,background:zone===z.id?C.surface:C.surface,cursor:"pointer",transition:"all .15s"}}>
                    <input type="radio" name="adminzone" value={z.id} checked={zone===z.id} onChange={e=>setZone(e.target.value)} style={{accentColor:C.ink}}/>
                    <div style={{flex:1}}>
                      <div style={{fontSize:"var(--text-body)",color:C.ink}}>{z.label}</div>
                      <div style={{fontSize:"var(--text-label)",color:C.ink}}>{z.days}</div>
                    </div>
                    <div style={{fontSize:"var(--text-body)",color:C.ink}}>{z.price===0?"Gratis":fmtMoney(z.price)}</div>
                  </label>
                ))}
              </div>
              {zone!=="pickup" && [["street","Dirección","Calle y número"],["city","Ciudad","Ciudad o municipio"],["dept","Departamento","Departamento"],["country","País","El Salvador"],["notes","Indicaciones","Timbre azul..."]].map(([k,l,ph])=>(
                <div key={k} style={{marginBottom:10}}>
                  <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:4}}>{l}</label>
                  {inp(addr[k], e=>setAddr(p=>({...p,[k]:e.target.value})), ph)}
                </div>
              ))}
            </div>
          )}
          {step===4 && (
            <div>
              <h3 style={{fontSize:"var(--text-body)",marginBottom:14,color:C.ink}}>Resumen</h3>
              <div style={{background:C.surface,borderRadius:2,padding:14,marginBottom:12,border:`1.5px solid ${C.rule}`}}>
                <div style={{fontSize:"var(--text-body)",color:C.ink}}>{cust.name}</div>
                <div style={{fontSize:"var(--text-body)",color:C.ink}}>{cust.phone}{cust.instagram&&` · ${cust.instagram}`}</div>
                <div style={{fontSize:"var(--text-label)",color:C.ink,marginTop:3}}>
                  {zone==="pickup"?"Recoger en persona":`${addr.street}, ${addr.city}, ${addr.country}`}
                </div>
              </div>
              {notes&&<div style={{background:C.surface,borderRadius:2,padding:"10px 14px",marginBottom:12,fontSize:"var(--text-body)",color:FEEDBACK.warning,border:`1px solid ${C.rule}`}}>{notes}</div>}
              <AdminOrderBreakdown items={items} zoneId={zone}/>
              <div style={{background:C.surface,borderRadius:2,padding:14,marginTop:12,border:`1.5px solid ${C.rule}`}}>
                <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:isPaid?12:0}}>
                  <input type="checkbox" checked={isPaid} onChange={e=>setIsPaid(e.target.checked)} style={{width:18,height:18,accentColor:C.ink}}/>
                  <span style={{fontSize:"var(--text-body)",color:isPaid?FEEDBACK.success:C.ink}}>{isPaid?`Pago recibido (${fmtMoney(total)})`:"Pago pendiente"}</span>
                </label>
                {isPaid&&(
                  <select value={payMethod} onChange={e=>setPay(e.target.value)}
                    style={{width:"100%",padding:"10px 12px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",background:C.surface,outline:"none",boxSizing:"border-box"}}>
                    <option value="">Método...</option>
                    {["Wompi","Efectivo","Transferencia","Otro"].map(m=><option key={m} value={m}>{m}</option>)}
                  </select>
                )}
              </div>
            </div>
          )}
        </div>

        <div style={{padding:"14px 26px",borderTop:`1.5px solid ${C.rule}`,display:"flex",gap:10,background:C.surface,flexShrink:0}}>
          {step>1&&<button onClick={()=>setStep(s=>s-1)} style={{padding:"11px 20px",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>← Atrás</button>}
          <button onClick={()=>step<4?setStep(s=>s+1):saveIt()}
            disabled={!ok||(step===1&&!cust.name)}
            style={{flex:1,padding:"12px 0",borderRadius:2,border:"none",background:C.ink,color:C.background,fontSize:"var(--text-body)",cursor:"pointer",opacity:(!ok||(step===1&&!cust.name))?.5:1}}>
            {step<4?"Continuar →":"Guardar pedido"}
          </button>
        </div>
      </div>
    </div>
  );
}

function AdminOrderDetail({ order, onClose, onUpdate, onDelete }) {
  const [status, setStatus]   = useState(order.status);
  const [isPaid, setIsPaid]   = useState(order.isPaid);
  const [payMethod, setPay]   = useState(order.payMethod);
  const safeItems = Array.isArray(order.items) ? order.items : [];
  const customerName = order.customer?.name || "Cliente sin nombre";
  const customerPhone = order.customer?.phone || "";
  const customerInstagram = order.customer?.instagram || "";
  const { total } = calcTotals(safeItems, order.shippingZone);
  const zone = SHIPPING_ZONES.find(z=>z.id===order.shippingZone);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(92,68,56,.45)",zIndex:600,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.background,borderRadius:2,width:"100%",maxWidth:500,maxHeight:"90vh",overflow:"auto"}}>
        <div className="on-ink" style={{background:C.inkStrong,padding:"20px 26px",borderRadius:2,display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{fontSize:"var(--text-label)",marginBottom:2}}>#{order.id} · {fmtDate(order.createdAt)}</div>
            <div style={{fontSize:"var(--text-body)",color:C.background}}>{customerName}</div>
            <div style={{fontSize:"var(--text-body)",marginTop:2}}>{customerPhone}{customerInstagram&&` · ${customerInstagram}`}</div>
          </div>
          <button onClick={onClose} style={{background:C.inkStrong,border:"none",borderRadius:2,width:30,height:30,cursor:"pointer",color:C.background,fontSize:"var(--text-body)",flexShrink:0}}>✕</button>
        </div>

        <div style={{padding:"20px 26px",display:"flex",flexDirection:"column",gap:12}}>
          <div style={{background:C.surface,borderRadius:2,padding:14,border:`1.5px solid ${C.rule}`}}>
            <div style={{fontSize:"var(--text-label)",color:C.ink,textTransform:"uppercase",letterSpacing:"1px",marginBottom:8}}>Estado</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {Object.entries(ORDER_STATUS).map(([k,cfg])=>(
                <button key={k} onClick={()=>setStatus(k)} className="label" style={{padding:"6px 11px",borderRadius:2,border:`1px solid ${status===k?cfg.color:C.rule}`,background:"transparent",color:status===k?cfg.color:C.ink,cursor:"pointer",transition:"border-color .15s, color .15s"}}>
                  {cfg.label}
                </button>
              ))}
            </div>
          </div>

          {order.shippingZone!=="pickup" && order.address?.street && (
            <div style={{background:C.surface,borderRadius:2,padding:14,border:`1.5px solid ${C.rule}`}}>
              <div style={{fontSize:"var(--text-label)",color:C.ink,textTransform:"uppercase",letterSpacing:"1px",marginBottom:6}}>Dirección</div>
              <div style={{fontSize:"var(--text-body)",color:C.ink,lineHeight:1.7}}>
                {order.address.street}<br/>{order.address.city}, {order.address.dept}<br/>{order.address.country}
                {order.address.notes&&<><br/><span style={{color:C.ink,fontSize:"var(--text-label)"}}>{order.address.notes}</span></>}
              </div>
              {zone&&<div style={{marginTop:6,fontSize:"var(--text-label)",color:C.ink}}>{zone.label} — {zone.days}</div>}
            </div>
          )}
          {order.shippingZone==="pickup"&&<div style={{background:C.surface,borderRadius:2,padding:"12px 14px",border:`1px solid ${C.rule}`,fontSize:"var(--text-body)",color:FEEDBACK.success}}>Recoger en persona — gratis</div>}
          {order.notes&&<div style={{background:C.surface,borderRadius:2,padding:"12px 14px",border:`1px solid ${C.rule}`,fontSize:"var(--text-body)",color:FEEDBACK.warning}}>{order.notes}</div>}

          <AdminOrderBreakdown items={safeItems} zoneId={order.shippingZone}/>

          <div style={{background:C.surface,borderRadius:2,padding:14,border:`1.5px solid ${C.rule}`}}>
            <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:isPaid?12:0}}>
              <input type="checkbox" checked={isPaid} onChange={e=>setIsPaid(e.target.checked)} style={{width:18,height:18,accentColor:C.ink}}/>
              <span style={{fontSize:"var(--text-body)",color:isPaid?FEEDBACK.success:C.ink}}>{isPaid?`Pagado — ${fmtMoney(total)}`:"Pago pendiente"}</span>
            </label>
            {isPaid&&(
              <select value={payMethod} onChange={e=>setPay(e.target.value)}
                style={{width:"100%",padding:"10px 12px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",background:C.surface,outline:"none",boxSizing:"border-box"}}>
                <option value="">Método...</option>
                {["Wompi","Efectivo","Transferencia","Otro"].map(m=><option key={m} value={m}>{m}</option>)}
              </select>
            )}
          </div>

          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>{if(window.confirm("¿Eliminar este pedido?"))onDelete(order.id)}} style={{padding:"10px 14px",borderRadius:2,border:`1px solid ${C.rule}`,background:C.surface,fontSize:"var(--text-body)",color:FEEDBACK.error,cursor:"pointer"}}></button>
            <button onClick={()=>onUpdate({...order,status,isPaid,payMethod:isPaid?payMethod:order.payMethod})}
              style={{flex:1,padding:"12px 0",borderRadius:2,border:"none",background:C.ink,color:C.background,fontSize:"var(--text-body)",cursor:"pointer"}}>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AdminDashboard({ orders, products, setOrders, soldIds, onRestock, onExit, onSaveProduct, onDeleteProduct }) {
  const [tab, setTab]           = useState("orders");
  const [showNew, setShowNew]   = useState(false);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter]     = useState("all");
  const [search, setSearch]     = useState("");
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [editProduct, setEditProduct]       = useState(null); // product being edited

  const saveOrder   = o => {
    const splitOrders = (Array.isArray(o.items) ? o.items : []).map((item, index) => ({
      ...o,
      id: `${o.id}-${index + 1}`,
      items: [item]
    }));
    setOrders(p=>[...p, ...(splitOrders.length ? splitOrders : [o])]);
    setShowNew(false);
  };
  const updateOrder = o => { setOrders(p=>p.map(x=>x.id===o.id?o:x)); setSelected(null); };
  const deleteOrder = id=> { setOrders(p=>p.filter(x=>x.id!==id)); setSelected(null); };

  const allProducts = products;

  const { active, pct, max } = calcCapacity(orders);
  const productLoad = calcProductLoad(orders);
  const totalRevenue = orders.filter(o=>o.isPaid).reduce((s,o)=>s+calcTotals(o.items,o.shippingZone).total,0);
  const capColor = pct>=90?FEEDBACK.error:pct>=70?FEEDBACK.warning:FEEDBACK.success;

  const filtered = orders
    .filter(o=>(filter==="all"||o.status===filter)&&(!search||o.customer.name.toLowerCase().includes(search.toLowerCase())||o.id.toLowerCase().includes(search.toLowerCase())))
    .sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));

  // ── Add/Edit Product Modal ───────────────────────────────────────────────
  const ProductForm = ({ existing, onClose }) => {
    const [name,     setName]     = useState(existing?.name     || "");
    const [price,    setPrice]    = useState(existing?.price    || "");
    const [cat,      setCat]      = useState(existing?.cat      || "Religiosos");
    const [stock,    setStock]    = useState(existing?.stock    ?? 1);
    const [desc,     setDesc]     = useState(existing?.desc     || "");
    const [tiempo,   setTiempo]   = useState(existing?.tiempo   || "5–7 días");
    const [dificultad, setDif]    = useState(existing?.dificultad || "Intermedio");
    const [badge,    setBadge]    = useState(existing?.badge    || "");
    const [imgData,  setImgData]  = useState(existing?.img      || null);
    const [imgError, setImgError] = useState("");
    const [cropOpen, setCropOpen] = useState(false);
    const [cropSource, setCropSource] = useState(null);
    const [cropScale, setCropScale] = useState(1);
    const [cropX, setCropX] = useState(0);
    const [cropY, setCropY] = useState(0);
    const [cropImgSize, setCropImgSize] = useState({ width: 0, height: 0 });
    const fileRef = useRef(null);
    const cropImageRef = useRef(null);

    const resetCropState = () => {
      setCropScale(1);
      setCropX(0);
      setCropY(0);
      setCropImgSize({ width: 0, height: 0 });
    };

    const openCropper = (source) => {
      setCropSource(source);
      resetCropState();
      setCropOpen(true);
    };

    const handleImage = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) { setImgError("Imagen muy grande (m??x 5MB)"); return; }
      const reader = new FileReader();
      reader.onload = (ev) => { openCropper(ev.target.result); setImgError(""); };
      reader.readAsDataURL(file);
    };

    const applyCrop = () => {
      const image = cropImageRef.current;
      if (!image) return;

      const frameSize = 900;
      const canvas = document.createElement("canvas");
      canvas.width = frameSize;
      canvas.height = frameSize;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const displayWidth = cropImgSize.width * cropScale;
      const displayHeight = cropImgSize.height * cropScale;
      const offsetX = (frameSize - displayWidth) / 2 + cropX;
      const offsetY = (frameSize - displayHeight) / 2 + cropY;

      ctx.fillStyle = C.background;
      ctx.fillRect(0, 0, frameSize, frameSize);
      ctx.drawImage(image, offsetX, offsetY, displayWidth, displayHeight);

      setImgData(canvas.toDataURL("image/jpeg", 0.92));
      setCropOpen(false);
      setCropSource(null);
    };

    const handleSave = () => {
      if (!name.trim() || !price || !imgData) return;
      const product = {
        id: existing?.id || ("custom_" + Date.now()),
        name: name.trim(),
        price: Number(price),
        cat, stock: Number(stock),
        desc: desc.trim() || `${name}, tejido por Abu.`,
        tiempo, dificultad, badge: badge.trim(),
        img: imgData,
        isCustom: true
      };
      onSaveProduct(product);
      onClose();
    };

    const inp = (val, cb, ph, type="text", extra={}) => (
      <input type={type} value={val} onChange={e=>cb(e.target.value)} placeholder={ph} {...extra}
        style={{width:"100%",padding:"10px 13px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",background:C.surface,boxSizing:"border-box"}}
        onFocus={e=>e.target.style.borderColor=C.ink}
        onBlur={e=>e.target.style.borderColor=C.rule}/>
    );

    const canSave = name.trim() && price && imgData;

    return (
      <>
      <div style={{position:"fixed",inset:0,background:"rgba(92,68,56,.45)",
        zIndex:700,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div style={{background:C.background,borderRadius:2,width:"100%",maxWidth:520,maxHeight:"94vh",
          overflow:"hidden",display:"flex",flexDirection:"column"}}>

          {/* Header */}
          <div className="on-ink" style={{background:C.ink,padding:"18px 24px",flexShrink:0,
            display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontSize:"var(--text-body)",color:C.background}}>
              {existing ? "Editar producto" : "Nuevo producto"}
            </div>
            <button onClick={onClose} style={{background:C.inkStrong,border:"none",borderRadius:2,
              width:30,height:30,cursor:"pointer",color:C.background,fontSize:"var(--text-body)",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>

          <div style={{flex:1,overflowY:"auto",padding:"20px 24px",display:"flex",flexDirection:"column",gap:14}}>

            {/* Server save notice */}
            <div style={{background:C.surface,border:`1px solid ${C.rule}`,borderRadius:2,padding:"10px 14px",
              display:"flex",alignItems:"flex-start",gap:10}}>
              <div style={{fontSize:"var(--text-label)",color:FEEDBACK.success,lineHeight:1.5}}>
                <strong>Se guarda en el servidor.</strong> Este producto aparecerá en el catálogo para todos los visitantes del sitio.
              </div>
            </div>

            {/* Image upload */}
            <div>
              <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:8}}>
                Foto del Producto *
</label>
              <div onClick={()=>fileRef.current?.click()}
                style={{width:"100%",height:180,borderRadius:2,border:`2.5px dashed ${imgData?C.ink:C.inkMuted}`,
                  background:imgData?"transparent":C.surface,cursor:"pointer",overflow:"hidden",
                  display:"flex",alignItems:"center",justifyContent:"center",position:"relative",transition:"border-color .2s"}}>
                {imgData
                  ? <img src={imgData} alt="preview" style={{width:"100%",height:"100%",objectFit:"contain",background:C.background,padding:4,boxSizing:"border-box"}}/>
                  : <div style={{textAlign:"center",color:C.ink}}>
                      <div style={{fontSize:"var(--text-body)"}}>Subir foto</div>
                      <div style={{fontSize:"var(--text-label)",marginTop:4}}>JPG, PNG · máx 5MB</div>
                    </div>
                }
                {imgData && (
                  <div style={{position:"absolute",inset:0,background:"transparent",display:"flex",
                    alignItems:"center",justifyContent:"center",opacity:0,transition:"opacity .2s"}}
                    onMouseEnter={e=>e.currentTarget.style.opacity=1}
                    onMouseLeave={e=>e.currentTarget.style.opacity=0}>
                    <div style={{background:"rgba(92,68,56,.45)",borderRadius:2,padding:"8px 16px",fontSize:"var(--text-label)",color:C.background}}>
                     Cambiar foto
                    </div>
                  </div>
                )}
              </div>
              <input ref={fileRef} type="file" accept="image/*" onChange={handleImage} style={{display:"none"}}/>
              {imgData && (
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8,gap:8,flexWrap:"wrap"}}>
                  <span style={{fontSize:"var(--text-label)",color:C.ink}}>
                   Ajusta la imagen para que quede centrada en la tarjeta del producto.
                  </span>
                  <button type="button" onClick={() => openCropper(imgData)} style={{padding:"6px 12px",borderRadius:2,border:`2px solid ${C.rule}`,background:C.surface,fontSize:"var(--text-label)",color:C.ink,cursor:"pointer"}}>
                   Recortar / Ajustar
                  </button>
                </div>
              )}
              {imgError && <p style={{fontSize:"var(--text-label)",color:FEEDBACK.error,marginTop:4}}>{imgError}</p>}
            </div>

            {/* Name + Price row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:12,alignItems:"end"}}>
              <div>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Nombre *</label>
                {inp(name, setName, "Ej: Ángel Tejido")}
              </div>
              <div style={{width:100}}>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Precio (USD) *</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",fontSize:"var(--text-body)",color:C.ink}}>$</span>
                  <input type="number" value={price} onChange={e=>setPrice(e.target.value)} placeholder="0"
                    min={1} step={0.01}
                    style={{width:"100%",padding:"10px 10px 10px 24px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",
                      background:C.surface,color:C.ink,boxSizing:"border-box"}}
                    onFocus={e=>e.target.style.borderColor=C.ink}
                    onBlur={e=>e.target.style.borderColor=C.rule}/>
                </div>
              </div>
            </div>

            {/* Category + Stock row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Categoría</label>
                <select value={cat} onChange={e=>setCat(e.target.value)}
                  style={{width:"100%",padding:"10px 13px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",background:C.surface,outline:"none",color:C.ink,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.ink}
                  onBlur={e=>e.target.style.borderColor=C.rule}>
                  {["Religiosos","Animales","Muñecas","Sets","Bebés","Otros"].map(c=><option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>
                 Unidades en stock
                </label>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <button onClick={()=>setStock(s=>Math.max(0,s-1))}
                    style={{width:36,height:40,borderRadius:2,border:`2px solid ${C.rule}`,background:C.surface,
                      fontSize:"var(--text-body)",cursor:"pointer",color:C.ink,flexShrink:0}}>−</button>
                  <input type="number" value={stock} onChange={e=>setStock(Math.max(0,Number(e.target.value)))}
                    min={0} style={{flex:1,padding:"10px 0",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",textAlign:"center",
                      outline:"none",background:C.surface,color:stock===0?FEEDBACK.error:C.ink}}
                    onFocus={e=>e.target.style.borderColor=C.ink}
                    onBlur={e=>e.target.style.borderColor=C.rule}/>
                  <button onClick={()=>setStock(s=>s+1)}
                    style={{width:36,height:40,borderRadius:2,border:`2px solid ${C.rule}`,background:C.surface,
                      fontSize:"var(--text-body)",cursor:"pointer",color:C.ink,flexShrink:0}}>+</button>
                </div>
                <div style={{fontSize:"var(--text-label)",color:C.ink,marginTop:4,textAlign:"center"}}>
                  {stock===0?"Se mostrará como agotado":stock===1?"Última unidad":stock+" unidades"}
                </div>
              </div>
            </div>

            {/* Badge + Tiempo row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Etiqueta (opcional)</label>
                {inp(badge, setBadge, "Ej: Nueva, Especial...")}
              </div>
              <div>
                <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Tiempo de entrega</label>
                {inp(tiempo, setTiempo, "Ej: 7–10 días")}
              </div>
            </div>

            {/* Dificultad */}
            <div>
              <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Dificultad</label>
              <div style={{display:"flex",gap:8}}>
                {["Fácil","Intermedio","Avanzado"].map(d=>(
                  <button key={d} onClick={()=>setDif(d)}
                    style={{flex:1,padding:"9px 0",borderRadius:2,border:`2px solid ${dificultad===d?C.ink:C.surface}`,
                      background:dificultad===d?C.surface:C.surface,fontSize:"var(--text-body)",color:dificultad===d?C.ink:C.ink,cursor:"pointer",transition:"all .15s"}}>
                    {d}
                  </button>
                ))}
              </div>
            </div>

            {/* Description */}
            <div>
              <label style={{fontSize:"var(--text-label)",color:C.ink,display:"block",marginBottom:5}}>Descripción</label>
              <textarea value={desc} onChange={e=>setDesc(e.target.value)} rows={3}
                placeholder="Describe el producto, materiales, detalles especiales..."
                style={{width:"100%",padding:"10px 13px",borderRadius:2,border:`2px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",resize:"vertical",
                  background:C.surface,lineHeight:1.6,boxSizing:"border-box"}}
                onFocus={e=>e.target.style.borderColor=C.ink}
                onBlur={e=>e.target.style.borderColor=C.rule}/>
            </div>
          </div>

          {/* Footer */}
          <div style={{padding:"14px 24px",borderTop:`1.5px solid ${C.rule}`,background:C.surface,flexShrink:0,display:"flex",gap:10}}>
            <button onClick={onClose}
              style={{padding:"11px 18px",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>
             Cancelar
            </button>
            <button onClick={handleSave} disabled={!canSave}
              style={{flex:1,padding:"13px 0",borderRadius:2,border:"none",
                background:canSave?C.ink:C.rule,
                color:C.background,fontSize:"var(--text-body)",
                cursor:canSave?"pointer":"not-allowed",
                transition:"background-color .2s"}}>
              {existing ? "Guardar cambios" : "Agregar producto"}
            </button>
          </div>
        </div>
      </div>

      {cropOpen && cropSource && (
        <div style={{position:"fixed",inset:0,background:"rgba(92,68,56,.45)",zIndex:800,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:C.background,borderRadius:2,width:"100%",maxWidth:640,overflow:"hidden"}}>
            <div className="on-ink" style={{background:C.ink,padding:"18px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:"var(--text-body)",color:C.background}}>Ajustar imagen</div>
              <button onClick={()=>{ setCropOpen(false); setCropSource(null); }} style={{background:C.inkStrong,border:"none",borderRadius:2,width:30,height:30,cursor:"pointer",color:C.background,fontSize:"var(--text-body)"}}>×</button>
            </div>
            <div style={{padding:24}}>
              <div style={{display:"grid",gridTemplateColumns:"minmax(0, 1fr) 180px",gap:20,alignItems:"start"}}>
                <div>
                  <div style={{width:"100%",maxWidth:380,aspectRatio:"1 / 1",margin:"0 auto",borderRadius:2,overflow:"hidden",background:C.background,border:`2px solid ${C.rule}`,position:"relative"}}>
                    <img ref={cropImageRef} src={cropSource} alt="Crop preview" onLoad={(e)=>setCropImgSize({ width: e.currentTarget.naturalWidth, height: e.currentTarget.naturalHeight })} style={{position:"absolute",top:"50%",left:"50%",width: cropImgSize.width ? `${cropImgSize.width * cropScale}px` : "100%",height: cropImgSize.height ? `${cropImgSize.height * cropScale}px` : "100%",objectFit:"contain",transform:`translate(calc(-50% + ${cropX}px), calc(-50% + ${cropY}px))`,transformOrigin:"center center",userSelect:"none",pointerEvents:"none"}} />
                  </div>
                  <p style={{fontSize:"var(--text-label)",color:C.ink,textAlign:"center",marginTop:10}}>Vista previa cuadrada de la foto final del producto.</p>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:14}}>
                  <label style={{fontSize:"var(--text-label)",color:C.ink}}>Zoom<input type="range" min="0.7" max="2.4" step="0.01" value={cropScale} onChange={e=>setCropScale(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <label style={{fontSize:"var(--text-label)",color:C.ink}}>Mover horizontal<input type="range" min="-220" max="220" step="1" value={cropX} onChange={e=>setCropX(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <label style={{fontSize:"var(--text-label)",color:C.ink}}>Mover vertical<input type="range" min="-220" max="220" step="1" value={cropY} onChange={e=>setCropY(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <button type="button" onClick={resetCropState} style={{padding:"10px 12px",borderRadius:2,border:`2px solid ${C.rule}`,background:C.surface,fontSize:"var(--text-label)",color:C.ink,cursor:"pointer"}}>Recentrar</button>
                </div>
              </div>
            </div>
            <div style={{padding:"16px 24px",borderTop:`1.5px solid ${C.rule}`,display:"flex",gap:10,justifyContent:"flex-end",background:C.surface}}>
              <button onClick={()=>{ setCropOpen(false); setCropSource(null); }} style={{padding:"11px 18px",borderRadius:2,border:`2px solid ${C.rule}`,background:"transparent",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>Cancelar</button>
              <button onClick={applyCrop} style={{padding:"12px 20px",borderRadius:2,border:"none",background:C.ink,color:C.background,fontSize:"var(--text-body)",cursor:"pointer"}}>Usar imagen</button>
            </div>
          </div>
        </div>
      )}
      </>
    );
  };

  return (
    <div style={{minHeight:"100vh",background:C.rule}}>
      <header className="on-ink" style={{background:C.inkStrong,padding:"0 20px",height:58,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <span className="logo-on-ink" style={{width:30,height:30,flexShrink:0}} role="img" aria-label="Handcrafts By Abu"/>
          <div>
            <div style={{color:C.background,fontSize:"var(--text-body)",lineHeight:1}}>Abu · Pedidos</div>
            <div style={{fontSize:"var(--text-label)",letterSpacing:"1.5px",textTransform:"uppercase"}}>Panel privado</div>
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{background:C.inkStrong,borderRadius:2,padding:"4px 12px",display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:capColor}}/>
            <span style={{color:C.background,fontSize:"var(--text-label)"}}>{active}/{max}</span>
          </div>
          <button onClick={()=>setShowNew(true)} style={{background:C.background,border:"none",borderRadius:2,padding:"7px 14px",fontSize:"var(--text-body)",color:C.ink,cursor:"pointer"}}>+ Pedido</button>
          <button onClick={onExit} style={{background:C.inkStrong,border:"none",borderRadius:2,padding:"7px 12px",fontSize:"var(--text-label)",cursor:"pointer"}}>← Salir</button>
        </div>
      </header>

      <div style={{maxWidth:960,margin:"0 auto",padding:"18px 14px"}}>
        <div style={{display:"flex",gap:3,marginBottom:18,background:C.background,borderRadius:2,padding:3,width:"fit-content"}}>
          {[["orders","Pedidos"],["stats","Stats"],["stock","Stock & Productos"]].map(([k,l])=>(
            <button key={k} onClick={()=>setTab(k)} style={{padding:"8px 14px",borderRadius:2,border:"none",fontSize:"var(--text-body)",cursor:"pointer",background:tab===k?C.ink:"transparent",color:tab===k?C.background:C.ink,transition:"all .2s"}}>{l}</button>
          ))}
        </div>

        {/* STATS TAB */}
        {tab==="stats" && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:12,marginBottom:18}}>
              {[
                {label:"Activos",value:`${active}/${max}`,color:C.ink},
                {label:"Pendientes",value:orders.filter(o=>o.status==="pending").length,color:FEEDBACK.warning},
                {label:"Tejiendo",value:orders.filter(o=>o.status==="weaving").length,color:C.inkStrong},
                {label:"Ingresos",value:fmtMoney(totalRevenue),color:FEEDBACK.success},
              ].map((s,i)=>(
                <div key={i} style={{background:C.background,borderRadius:2,padding:16,border:`1px solid ${C.rule}`}}>
                  <div style={{fontSize:"var(--text-body)",color:s.color}}>{s.value}</div>
                  <div className="label" style={{marginTop:6}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <div style={{background:C.background,borderRadius:2,padding:16,border:`1.5px solid ${C.rule}`}}>
                <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:10}}>Capacidad Total</div>
                <div style={{background:C.surface,borderRadius:2,height:12,overflow:"hidden",marginBottom:6}}>
                  <div style={{height:"100%",borderRadius:2,width:`${Math.min(pct,100)}%`,background:pct>=90?FEEDBACK.error:pct>=70?FEEDBACK.warning:C.ink,transition:"width .5s"}}/>
                </div>
                <div style={{fontSize:"var(--text-label)",color:capColor}}>
                  {pct>=90?"Capacidad llena":pct>=70?"Carga alta":pct>=40?"Carga moderada":"Disponible"}
                </div>
              </div>
              <div style={{background:C.background,borderRadius:2,padding:16,border:`1.5px solid ${C.rule}`}}>
                <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:10}}>Por Producto</div>
                {allProducts.map(p=>{
                  const c = productLoad[p.id]||0;
                  const pct2 = Math.round(c/MAX_PER_PRODUCT*100);
                  const col = pct2>=100?FEEDBACK.error:pct2>=75?FEEDBACK.warning:FEEDBACK.success;
                  return (
                    <div key={p.id} style={{marginBottom:7}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                        <span style={{fontSize:"var(--text-label)",color:C.ink,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:120}}>{p.name}</span>
                        <span style={{fontSize:"var(--text-label)",color:col,flexShrink:0}}>{c}/{MAX_PER_PRODUCT}</span>
                      </div>
                      <div style={{background:C.surface,borderRadius:2,height:6,overflow:"hidden"}}>
                        <div style={{height:"100%",borderRadius:2,width:`${Math.min(pct2,100)}%`,background:pct2>=100?FEEDBACK.error:pct2>=75?FEEDBACK.warning:C.ink,transition:"width .4s"}}/>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div style={{marginTop:14,background:C.background,borderRadius:2,padding:16,border:`1.5px solid ${C.rule}`}}>
              <div style={{fontSize:"var(--text-body)",color:C.ink,marginBottom:12}}>Estado de Pedidos</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {Object.entries(ORDER_STATUS).map(([k,cfg])=>(
                  <div key={k} style={{padding:"10px 14px",minWidth:80}}>
                    <div style={{fontSize:"var(--text-body)",color:cfg.color}}>{orders.filter(o=>o.status===k).length}</div>
                    <div className="status-label" style={{color:cfg.color,marginTop:6}}>{cfg.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ORDERS TAB */}
        {tab==="orders" && (
          <div>
            <div style={{background:C.background,borderRadius:2,padding:"11px 14px",marginBottom:14,display:"flex",flexWrap:"wrap",gap:8,alignItems:"center",border:`1.5px solid ${C.rule}`}}>
              <div style={{position:"relative",flex:"1 1 150px"}}>
                <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar..."
                  style={{width:"100%",padding:"8px 10px",borderRadius:2,border:`1px solid ${C.rule}`,fontSize:"var(--text-body)",outline:"none",background:C.background,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.ink} onBlur={e=>e.target.style.borderColor=C.rule}/>
              </div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {[["all","Todos"],["pending","Pendiente"],["weaving","Tejiendo"],["ready","Listo"],["shipped","Enviado"],["delivered","Entregado"]].map(([v,l])=>(
                  <button key={v} onClick={()=>setFilter(v)} style={{padding:"5px 11px",borderRadius:2,border:`2px solid ${filter===v?C.ink:C.surface}`,background:filter===v?C.ink:"transparent",color:filter===v?C.background:C.ink,fontSize:"var(--text-label)",cursor:"pointer",transition:"all .15s"}}>{l}</button>
                ))}
              </div>
              <span style={{fontSize:"var(--text-label)",color:C.ink}}>{filtered.length} pedidos</span>
            </div>
            {filtered.length===0?(
              <div style={{textAlign:"center",padding:"44px 0",color:C.ink}}>
                <div style={{fontSize:"var(--text-body)"}}>No hay pedidos</div>
              </div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {filtered.map(order=>{
                  const safeOrderItems = Array.isArray(order.items) ? order.items : [];
                  const { total } = calcTotals(safeOrderItems, order.shippingZone);
                  const cfg = ORDER_STATUS[order.status] || ORDER_STATUS.pending;
                  const customerName = order.customer?.name || "Cliente sin nombre";
                  return (
                    <div key={order.id} onClick={()=>setSelected(order)}
                      style={{background:C.background,borderRadius:2,padding:"14px 18px",border:`1.5px solid ${C.rule}`,cursor:"pointer",display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",transition:"all .18s"}}
                      onMouseEnter={e=>{e.currentTarget.style.borderColor=C.ink;}}
                      onMouseLeave={e=>{e.currentTarget.style.borderColor=C.rule;}}>
                      <div style={{width:9,height:9,borderRadius:"50%",background:cfg.color,flexShrink:0}}/>
                      <div style={{flex:"1 1 130px"}}>
                        <div style={{fontSize:"var(--text-body)",color:C.ink}}>{customerName}</div>
                        <div style={{fontSize:"var(--text-label)",color:C.ink}}>{order.id} · {fmtDate(order.createdAt)}</div>
                      </div>
                      <div style={{flex:"2 1 150px",fontSize:"var(--text-body)",color:C.ink,overflow:"hidden"}}>
                        {order.items.map(i=>`${i.name} ×${i.qty}`).join(" + ")}
                        {order.notes&&<div style={{fontSize:"var(--text-label)",color:C.ink,marginTop:1,fontStyle:"italic",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:200}}>{order.notes}</div>}
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontSize:"var(--text-body)",color:C.ink}}>{fmtMoney(total)}</div>
                        <div style={{fontSize:"var(--text-label)",marginTop:2}}>{order.isPaid?<span style={{color:FEEDBACK.success}}>Pagado</span>:<span style={{color:FEEDBACK.warning}}>Pendiente</span>}</div>
                      </div>
                      <span className="status-label" style={{flexShrink:0,color:cfg.color}}>{cfg.label}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* STOCK & PRODUCTS TAB */}
        {tab==="stock" && (
          <div>
            {/* Header row */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{fontSize:"var(--text-body)",color:C.ink}}>
                  Catálogo · {allProducts.length} productos
                </div>
                <div style={{fontSize:"var(--text-label)",color:C.ink,marginTop:2}}>
                 Agrega, edita o gestiona el stock de tus piezas
                </div>
              </div>
              <button onClick={()=>{ setEditProduct(null); setShowAddProduct(true); }}
                style={{display:"flex",alignItems:"center",gap:8,padding:"11px 20px",borderRadius:2,border:"none",
                  background:C.ink,color:C.background,fontSize:"var(--text-body)",cursor:"pointer"}}>
                Agregar Producto
              </button>
            </div>

            {/* Product list */}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {allProducts.map(p => {
                const sold = soldIds && soldIds.includes(p.id);
                const stockNum = typeof p.stock === "number" ? p.stock : 1;
                const outOfStock = sold || stockNum === 0;
                return (
                  <div key={p.id} style={{background:C.background,borderRadius:2,padding:"14px 16px",
                    border:`1.5px solid ${outOfStock?C.surface:C.surface}`,
                    display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
                    <img src={p.img} alt={p.name} style={{width:58,height:58,objectFit:"cover",
                      borderRadius:2,flexShrink:0,filter:outOfStock?"grayscale(50%)":"none",
                      border:`1.5px solid ${C.rule}`}}/>
                    <div style={{flex:1,minWidth:120}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                        <div style={{fontSize:"var(--text-body)",color:C.ink}}>{p.name}</div>
                        <span style={{fontSize:"var(--text-label)",padding:"2px 7px",borderRadius:2,background:`${C.rule}`,color:C.inkStrong}}>
                          {p.isCustom ? "CUSTOM" : "CATALOG"}
                        </span>
                      </div>
                      <div style={{fontSize:"var(--text-label)",color:C.ink,marginTop:2}}>
                        <span style={{color:C.ink}}>{fmtMoney(p.price)}</span>
                        <span style={{margin:"0 6px"}}>·</span>
                        {p.cat}
                        <span style={{margin:"0 6px"}}>·</span>
                        {outOfStock
                          ? <span style={{color:FEEDBACK.error}}>Agotado</span>
                          : <span style={{color:FEEDBACK.success}}>
                              {stockNum === 1 ? "Última unidad" : `${stockNum} unidades`}
                            </span>
                        }
                      </div>
                    </div>
                    <div style={{display:"flex",gap:7,flexShrink:0,flexWrap:"wrap",alignItems:"center"}}>
                      {outOfStock && (
                        <button onClick={()=>onRestock(p.id)}
                          style={{padding:"6px 12px",borderRadius:2,border:`2px solid ${C.ink}`,
                            background:C.surface,fontSize:"var(--text-label)",color:C.ink,cursor:"pointer"}}>
                          ↺ Reponer
                        </button>
                      )}
                      <button onClick={()=>{ setEditProduct(p); setShowAddProduct(true); }}
                        style={{padding:"6px 12px",borderRadius:2,border:`2px solid ${C.rule}`,
                          background:C.surface,fontSize:"var(--text-label)",color:C.ink,cursor:"pointer"}}>
                       Editar
                      </button>
                      <button onClick={()=>{ if(window.confirm(`¿Eliminar "${p.name}"?`)) onDeleteProduct(p.id); }}
                        style={{padding:"6px 12px",borderRadius:2,border:`1px solid ${C.rule}`,
                          background:C.surface,fontSize:"var(--text-label)",color:FEEDBACK.error,cursor:"pointer"}}>
                       Eliminar
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {showNew  && <AdminNewOrder orders={orders} onSave={saveOrder} onClose={()=>setShowNew(false)} products={allProducts}/>}
      {selected && <AdminOrderDetail order={selected} onClose={()=>setSelected(null)} onUpdate={updateOrder} onDelete={deleteOrder}/>}
      {showAddProduct && (
        <ProductForm
          existing={editProduct}
          onClose={()=>{ setShowAddProduct(false); setEditProduct(null); }}
        />
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  MAIN SITE COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

export default AdminDashboard;

